import { useState } from 'react'
import { Link } from "react-router-dom"
import firma from '../images/gogobits.svg'
import { useTranslation } from 'react-i18next';
import whatsapp from '../images/whatsapp.svg'

const Navbar = () => {
    const {i18n} = useTranslation()
const [show, setShow] = useState()
    const lngs = {
        en: {nativeName: 'English'},
        es: {nativeName: 'Español'}
    }
    
    return (
        <nav className="flex flex-row items-center justify-evenly flex-wrap bg-white">
                <img src={firma} className='px-2 py-2' alt="signature" width={150}/>
                <a target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" href="https://wa.me/524422590423?text=Hello, I'm interested in your services, my name is"> <img alt="Chat on WhatsApp" src={whatsapp} height={35} width={35} className='hidden'/></a>
            <div className="block lg:hidden mx-8">
                <button className="flex items-center px-3 py-2 border rounded text-orange-500 border-orange-500 hover:text-black hover:border-orange-500 " onClick={()=>setShow(!show)}>
                    <svg className="fill-current h-3 w-3" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
                </button>
            </div>
            
            <div className={"pb-8 w-full block flex-grow lg:flex lg:items-center lg:w-auto "+ (show ? " flex flex-col" : " hidden")}>
                <div className="text-sm lg:flex-grow sm:flex sm:flex-row md:pt-2 ">
                <Link to="/" className="block mt-4 lg:inline-block lg:mt-0 text-orange-500 hover:text-black ml-4 sm:pt-4" >
                    Home
                </Link>
                <Link to="/bookacall" className="block mt-4 lg:inline-block lg:mt-0 text-orange-500 hover:text-black ml-4 sm:pt-4" >
                    Book a call now!
                </Link>
                
                    {Object.keys(lngs).map((lng) => (
                        <button className='mx-8 block mt-4 lg:inline-block lg:mt-0 text-orange-500 hover:text-black ml-4' type='submit' key={lng} onClick={() => i18n.changeLanguage(lng) && window.location.reload(false)} disabled={i18n.resolvedLanguage === lng}>{lngs[lng].nativeName}</button>
                    ))}
                <a target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" href="https://wa.me/524422590423?text=Hello, I'm interested in your services, my name is"> <img alt="Chat on WhatsApp" src={whatsapp} height={35} width={35} className="ml-2 my-2"/></a>
                </div>
            </div>
                                
            
        </nav>
    )
}

export default Navbar